import {
  Modal,
  Button,
  Group,
  TextInput,
  Select,
  Textarea,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import IconPlus from "@tabler/icons-react/dist/esm/icons/IconPlus.mjs";
import { useMutation } from "@tanstack/react-query";
import { useForm, Controller } from "react-hook-form";
import { create } from "../../../services/rules";
import { toast } from "react-toastify";
import { errorMsg } from "../../../utils/vars";
import { useNavigate } from "react-router-dom";

const RULE_TYPES = [
  { value: "PTM", label: "PTM" },
  { value: "RTM", label: "RTM" },
];

const CreateRuleModal = () => {
  const navigate = useNavigate();
  const [opened, { open, close }] = useDisclosure(false);

  const { handleSubmit, control } = useForm({
    defaultValues: {
      typeOfRule: RULE_TYPES[0].value,
      name: "",
      description: "",
    },
  });

  const ruleMutation = useMutation({
    mutationKey: "create-rule-mutation",
    mutationFn: create,
    onSuccess: ({ id }) => {
      navigate(`/rules/rule-dashboard/${id}`);
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || errorMsg);
    },
  });

  const onSubmit = (data) => {
    ruleMutation.mutate({
      ...data,
      type: "BASIC",
    });
  };

  return (
    <>
      <Modal opened={opened} onClose={close} title="Create Rule" centered>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="typeOfRule"
            control={control}
            render={({ field }) => (
              <Select {...field} allowDeselect={false} data={RULE_TYPES} />
            )}
          />
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextInput {...field} label="Rule name" required />
            )}
          />
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <Textarea {...field} label="Description" required maxRows={5} />
            )}
          />
          <Group justify="flex-end" mt="md">
            <Button loading={ruleMutation.isPending} type="submit">
              Submit
            </Button>
          </Group>
        </form>
      </Modal>

      <Group justify="flex-end">
        <Button leftSection={<IconPlus size={16} />} onClick={open}>
          Create
        </Button>
      </Group>
    </>
  );
};

export default CreateRuleModal;
